import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { featureEnabled } from 'utils';
import { Button, Text, theme } from 'components';
import { Button as ButtonV2 } from '@bb/elements-web';
import styled from 'styled-components';
import { AuthContext } from 'contexts';
import LockOutlined from '@ant-design/icons/LockOutlined';
import { LockboxPermissionsManagerModal } from 'modals';
import { handleLockboxPermissionsConfirm } from 'utils/lockboxPermissionsHandler';
import SearchBar from './SearchBar';
import { useLockboxesContext } from './LockboxesContext';

const LockboxesRightHeader: React.FC = () => {
  const { auth } = React.useContext(AuthContext);
  const features = auth?.org.features;
  const [lockboxPermissionsModalVisible, setLockboxPermissionsModalVisible] =
    useState(false);
  const {
    setCurrentLockbox,
    total,
    initialTotal,
    loading,
    showTable,
    setShowTable,
    selectedLockboxes,
  } = useLockboxesContext();

  const history = useHistory();
  const handleActivityClickBtn = () => {
    const query = selectedLockboxes.reduce(
      (acc, lockbox) => `${acc}${lockbox},`,
      '',
    );
    history.push(`/lockboxesActivities?lockboxIds=${query}`);
  };

  const handleQuickAssignActivityClickBtn = () => {
    history.push(`/mls/quick-assignment-activity`);
  };

  if (!showTable) return null;

  return (
    <>
      <StyledContainer>
        {featureEnabled('bulkLockboxPermissionsFeature', 1) && (
          <Button onClick={() => setLockboxPermissionsModalVisible(true)}>
            <LockOutlined />
            Manage Permissions
          </Button>
        )}

        {featureEnabled('quickLockboxAssignmentFeature') && !loading && (
          <>
            <Button
              disabled={!selectedLockboxes.length}
              onClick={handleActivityClickBtn}
            >
              View Activities
            </Button>
            <StyledText data-count={total} data-total={initialTotal}>
              {total} of {initialTotal} Lockboxes
            </StyledText>
          </>
        )}

        {featureEnabled('quickLockboxAssignmentFeature') &&
          features.includes('MLS_STAFF_QUICK_LOCKBOX_ASSIGNMENT') && (
            <>
              <Button
                disabled={!selectedLockboxes.length}
                onClick={handleQuickAssignActivityClickBtn}
              >
                View Quick Assignment Activities
              </Button>
            </>
          )}

        <SearchBar />

        {(['sentriLock', 'masterLock'] as const).some(
          (lockboxType: 'sentriLock' | 'masterLock') =>
            !auth.org.lockboxVendorSettings ||
            auth.org.lockboxVendorSettings[lockboxType],
        ) && (
          <ButtonV2
            dataCy="add-lockbox-button"
            size="small"
            onClick={() => {
              setCurrentLockbox(null);
              setShowTable(false);
            }}
          >
            + New Lockbox
          </ButtonV2>
        )}
      </StyledContainer>

      <LockboxPermissionsManagerModal
        visible={lockboxPermissionsModalVisible}
        loggedInUser={auth}
        onConfirmAndProcess={handleLockboxPermissionsConfirm}
        onCancel={() => setLockboxPermissionsModalVisible(false)}
      />
    </>
  );
};

export default LockboxesRightHeader;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 5px;
`;

const StyledText = styled(Text)`
  color: ${theme.textColorSecondary};
  font-size: 14px;
`;
